import React, { useContext } from "react";
import styled from "@emotion/styled";
import PropTypes from "prop-types";
import Context from "../EventsProvider";

//style rules
import { Colors, Typography, Sizes } from "../../../styles";

const CardTags = ({isFree, isOnline, eventLanguage}) => {
	const { data: { language } } = useContext(Context);

	const renderIsFree = () => {
		if (!isFree) return null;
		return <CardCategory>{language === "en" ? "free" : "gratuit"}</CardCategory>;
	}

	const renderIsOnline = () => {
		if (!isOnline) return null;
		return <CardCategory>{language === "en" ? "online" : "en ligne"}</CardCategory>;
	}

	const renderLanguage = () => {
		if (!eventLanguage) return null;

		if (eventLanguage === 'fr') {
			return <CardCategory>{language === "en" ? "french" : "français"}</CardCategory>;
		}

		if (eventLanguage === 'en') {
			return <CardCategory>{language === "en" ? "english" : "anglais"}</CardCategory>;
		}
	}

	return  (
		<>
			{renderIsOnline()}
			{renderLanguage()}
			{renderIsFree()}
		</>
	);
}

CardTags.propTypes = {
	isFree: PropTypes.bool,
	isOnline: PropTypes.bool,
	eventLanguage: PropTypes.string
};

export default CardTags;

const CardCategory = styled.li`
	font-size: 1rem;
	font-weight: ${Typography.fontWeight.bold};
	text-transform: uppercase;
	line-height: 1.22rem;
	padding: 0.5rem 1rem;
	color: ${Colors.fp.teal};
	background-color: ${Colors.fp.teal10};
	border-radius: 2rem;
	display: inline-block;
	margin-bottom: 1rem;
	margin-right: 0.4rem;

	@media only screen and (min-width: ${Sizes.screens.large}) {
		font-size: 1.1rem;
		letter-spacing: 0.01rem;
	}
`;
